
import { defineComponent } from "@vue/runtime-core"

  export default defineComponent({
    data() {
      return {}
    },
    props: ["stories"]
  });
